import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const GreylistAreaAddEditRBAC = {
  pageID: '89d87595d23576b5d38f701713977845',
  elementID: {
    ViewPage: 'f21f925c38b7c1a28dbe25b2c5727aab',
    AddLocation: '9f3bcdcee54387da61a1c4049d30c9cb',
    Save: 'd2d56b9dc5b7c1a29d4bf39a98e896fa',
  },
} as const

export const useGreylistAreaAddEditRBACPage = createUseRBAC(GreylistAreaAddEditRBAC.elementID)

export type UseGreylistAreaAddEditRBACPageType = ReturnType<typeof useGreylistAreaAddEditRBACPage>
